import { ResourceService } from 'src/app/services/resource.service';
import { SearchService } from 'src/app/services/search.service';
import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';
import { BookingService } from 'src/app/services/booking.service';
import { Component, OnInit, Inject, Input, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { TranslateService } from '@ngx-translate/core';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { DepositeType, PaymentMethodsEnum, PaymentMode, PaymentSharedComponentErrors, ProceedPaymentResponseResult, RentalServiceDeliveryChannel } from 'src/app/models/enums/Payments/PaymnetsEnum';
import { AvailablePaymentMethodModel } from 'src/app/models/Payments/AvailablePaymentMethodModel';
import { ProceedPaymentModel } from 'src/app/models/Payments/ProceedPaymentModel';
import { VehicleReservationCaseResult } from 'src/app/models/Booking/VehicleReservationCaseResult';
import { Router } from '@angular/router';
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import {  EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'pay-modal',
  templateUrl: './pay-modal.component.html',
  styleUrls: ['./pay-modal.component.scss']
})
export class PayModalComponent implements OnInit,OnDestroy {

  clickPay: boolean = false;

  faChevronCircleLeft = faChevronCircleLeft;
  //viewBooking:ViewBookingModel;
  faTimesCircle = faTimesCircle;
  PaymentMethods;
  paymentMethodList: AvailablePaymentMethodModel[];
  currency: any;
  accountCreditPostBackMsg: string;
  amount: number;
  submitClicked:boolean=false;
  @Input() viewBooking:ViewBookingModel;
  @Output() onCancel= new EventEmitter();
  submitted: boolean=false;
  rentalServiceDeliveryChannel = RentalServiceDeliveryChannel.Online;





  constructor(
   /*  private dialogRef: MatDialogRef<PayModalComponent>,
    @Inject(MAT_DIALOG_DATA)private data, */
    private formBuilder: FormBuilder,
    public translateService: TranslateService,
    private dialog: MatDialog,
    private bookingService: BookingService,
    private router: Router,
    private searchService:SearchService,
    private resourceService:ResourceService
  ) { }
  ngOnDestroy(): void {

   this.resourceService.updatePaymentFlag(false);
  }



  ngOnInit() {
    this.currency=this.searchService.getCurrency();
/*     if(this.data!=null&&this.data.viewBooking!=null){
      this.viewBooking=this.data.viewBooking;
    } */

  }


  get paymentMethods() {
    return PaymentMethodsEnum;
  }
  get PaymentMode() {
    return PaymentMode;
  }



  close(): void {
    //this.dialogRef.close();
  }

  form = new FormGroup({
    amount: new FormControl(null, [Validators.required,Validators.min(0.1)]),

  });



  changeViewType(clickPay) {
    this.clickPay = true;
  }


  cancelClicked(){

    this.submitted=false;
    this.onCancel.emit(true);
  }

  onError(val){

  }

  submit(){

    this.submitClicked=true;
    if(this.form.invalid){
      return
    }
    this.submitted=true;
  }



}
